import __request__ from "routing/request";
export function clusterHealth(requestOptions) {
  return __request__("GET", "/system/indexer/cluster/health", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function clusterInfo(requestOptions) {
  return __request__("GET", "/system/indexer/cluster/info", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function clusterName(requestOptions) {
  return __request__("GET", "/system/indexer/cluster/name", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
